import React, { FC } from 'react';

import { CellContext } from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { formatDate, formatLongDate } from '../../../utils';

export const CreatedAtCell: FC<
  CellContext<EntitlementsProject, EntitlementsProject['createdAt']>
> = ({ row, getValue }) => (
  <OverflowTooltip
    triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}
    content={formatLongDate(getValue())}
  >
    <span data-testid={`ProjectCreateTimeTooltip:${row.original.id}`}>
      {formatDate(getValue())}
    </span>
  </OverflowTooltip>
);
